import React, { useState, useEffect, useContext } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { getComments } from "../../../services/tribe";
import GlobalContext from "../../../contexts/globalContext";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import Loading from "../../atoms/loading/loading";
import CardComment from "../../atoms/card-comment/cardComment";
import CommentInput from "../../molecules/comment-input/commentInput";
import CommentDetailModal from "../comment-detail-modal/commentDetailModal";
import MobileCommentModal from "../../molecules/mobile-comment-modal/mobileCommentModal";
import ModalApprove from "../../atoms/modal-approve/modalApprove";

interface CommentsSideProps {
  title: { json: any };
  conversationId: string;
  textLogin: string;
  sectionTitle: string;
}

const CommentsSide = (props: CommentsSideProps) => {
  const [userUid, setUserUid] = useState<any>(undefined);
  const [userId, setUserId] = useState("");
  const [userInfo, setUserInfo] = useState<any>({});
  const [isReady, setIsReady] = useState(false);
  const [comments, setComments] = useState<Array<any>>([]);
  const [idxSelection, setIdxSelection] = useState<any>(undefined);
  const [showNewCommentModal, setShowNewCommentModal] = useState(false);
  const [showCommentMsgModal, setShowCommentMsgModal] = useState(false);
  const [editingComment, setEditingComment] = useState<any>(undefined);
  const [editingId, setEditingId] = useState<any>("");
  const { gigyaContext: { gigyaAccount, login }, gigyaUid } = useContext(GlobalContext);
  const { window } = useBrowserMode();

  useEffect(() => {
    const getCommentsFn = async () => {
      setIsReady(false);
      setUserId("");
      setUserInfo(gigyaAccount?.profile || {});
      if (props.conversationId) {
        const conversationId = props.conversationId;
        const response: any = await getComments(
          conversationId,
          gigyaAccount?.profile && gigyaAccount?.profile.email,
          gigyaAccount?.profile.firstName +
            " " +
            gigyaAccount?.profile.lastName || "",
          gigyaAccount?.UID || ""
        );
        setIsReady(true);
        setUserId(response.userId);
        setComments([]);
        setComments(response.comments.length ? [...response.comments] : []);
        setUserUid(gigyaAccount?.UID || null);
      } else {
        setComments([]);
        setIsReady(true);
      }
    };
    getCommentsFn();
  }, [gigyaAccount?.UID]);

  useEffect(() => {
    if (gigyaUid?.get !== userUid && userUid !== undefined) {
      window.location.reload();
    }
  }, [gigyaUid?.get]);

  const handleSelection = (commentId: string) => {
    const commentIndex = comments.findIndex((com) => com.id === commentId);
    setIdxSelection(commentIndex);
  };

  const handleEditingComment = (orginalComment, commentId) => {
    setEditingComment(orginalComment);
    setEditingId(commentId);
  };

  return (
    <div
      className={`o-current-conversation__content__right__container ${
        !comments.length
          ? "o-current-conversation__content__right__container--empty"
          : ""
      }  
      `}
    >
      <h3 className="o-current-conversation__content__right__title">
        Comentarios
      </h3>
      {isReady ? (
        comments.length > 0 ? (
          <div className="o-current-conversation__content__right__comments">
            {comments.map((comment, index) => (
              <CardComment
                key={index}
                {...comment}
                userId={userId}
                userInfo={userInfo}
                handleSelection={handleSelection}
                gigyaAccount={gigyaAccount}
                editingCommentHandler={handleEditingComment}
                handleNewCommentModal={setShowNewCommentModal}
              />
            ))}
          </div>
        ) : (
          <div
            className={`o-current-conversation__content__right__empty ${
              !userInfo.email
                ? "o-current-conversation__content__right__empty--no-user"
                : ""
            }`}
          >
            <i className="o-current-conversation__content__right__empty__icon icon-comments1"></i>
            <div className="o-current-conversation__content__right__empty__text">
              {documentToReactComponents(props.title.json)}
            </div>
          </div>
        )
      ) : (
        <Loading />
      )}
      <div className="o-current-conversation__content__right__divider"></div>
      <div
        className={`o-current-conversation__content__right__new-comment ${
          !userInfo.email
            ? "o-current-conversation__content__right__new-comment--login"
            : ""
        } ${
          !userInfo.email && !comments.length
            ? "o-current-conversation__content__right__new-comment--login-empty"
            : ""
        }`}
        onClick={() => (userInfo.email ? setShowNewCommentModal(true) : false)}
      >
        {userInfo.email ? (
          <CommentInput
            gigyaAccount={gigyaAccount}
            discussionId={props.conversationId}
          />
        ) : (
          <p
            className="o-current-conversation__content__right__new-comment__login-text"
            onClick={login}
          >
            {props.textLogin}
          </p>
        )}
      </div>
      <CommentDetailModal
        title={props.sectionTitle || ""}
        setCommentIdx={setIdxSelection}
        totalComments={comments}
        commentIdx={idxSelection}
        userId={userId}
        userInfo={userInfo}
        gigyaAccount={gigyaAccount}
        showNewCommentModal={setShowNewCommentModal}
      />
      {showNewCommentModal && (
        <MobileCommentModal
          closeModal={() => setShowNewCommentModal(false)}
          closeModalPublish={() => {
            setShowNewCommentModal(false);
            setShowCommentMsgModal(true);
          }}
          valueInput={editingComment}
          updatingComment={editingId}
          urlImage={null}
          idConversation={props.conversationId}
        />
      )}
      <ModalApprove
        onClose={() => {
          setShowCommentMsgModal(false);
          window.location.reload();
        }}
        open={showCommentMsgModal}
      />
    </div>
  );
};

export default CommentsSide;
